/**
 * 1v1 qidiruv so'rovlari — docs/API.md §5.
 *
 * `POST /match/search` javobi faqat "pul yechildi va navbatga kirdik"
 * degani. HAQIQIY natija WS orqali keladi: `match.found` yoki
 * `match.timeout`.
 */

import type { CancelResponse, SearchRequest, SearchResponse } from '@voice/api-client';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { ME_KEY } from './useMe';
import { WALLET_KEY } from './useWallet';
import { request } from './client';

export function useStartSearch() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (body: SearchRequest) =>
      request<SearchResponse>('/match/search', { method: 'POST', body }),
    // Qidiruv pullik (D-016) — balans darhol o'zgaradi.
    onSuccess: () => {
      void client.invalidateQueries({ queryKey: WALLET_KEY });
      void client.invalidateQueries({ queryKey: ME_KEY });
    },
  });
}

export function useCancelSearch() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: () => request<CancelResponse>('/match/search', { method: 'DELETE' }),
    // Bekor qilinganda diamond QAYTARILADI — balans yana o'zgaradi.
    onSuccess: () => {
      void client.invalidateQueries({ queryKey: WALLET_KEY });
      void client.invalidateQueries({ queryKey: ME_KEY });
    },
  });
}
